import { observer } from 'mobx-react-lite';
import React from 'react';
import { CurveStatus } from '../../stores/SourceDataMap';
import { Tablet } from '../../stores/Tablet';
import { Curve } from '../../stores/Tracks';
import { LoaderString } from './LoaderString';
import { CuttingsBlock } from './TabletTracksInfo.styled';

type Props = {
  tablet: Tablet;
  source: Curve;
  collapsed: boolean
  onClick: React.MouseEventHandler<HTMLDivElement>
  onContextMenu: React.MouseEventHandler<HTMLDivElement>
};

export const CuttingsHeader = observer(({
  tablet, source, collapsed, onClick, onContextMenu,
} : Props) => (
  <CuttingsBlock
    color={source.sourceData?.imageLithology?.color}
    key={source.sourceDto.externalId}
    onClick={onClick}
    onContextMenu={onContextMenu}
    collapsed={collapsed}
    selected={tablet.tracks.selectedSource === source}
    reverse={source.params.legendPosition === 'bottom'}
  >
    {source.sourceData?.imageLithology?.image && (
      <img
        alt={source.sourceDto.name}
        src={source.sourceData?.imageLithology.image.src}
        style={{ width: 15, height: 15, margin: collapsed ? 1 : 3 }}
      />
    )}
    <div>{source.sourceDto.name}</div>
    {(source.sourceData?.status === CurveStatus.ServerFetching
      || source.sourceData?.status === CurveStatus.MetaDataFetching
      || source.sourceData?.status === CurveStatus.NoData)
      && (<LoaderString source={source} position="right" />)}
  </CuttingsBlock>
));
